<template>
	<div>
		
		<div class="pageFrom  animate__animated  ">
			<div class="sec-title">
				<el-image :src="require('@/static/CodeBuddyAssets/31270_3509/24.svg')"></el-image>
				<span>{{$t('marks.t1')}}</span>
			</div>
			
			<div class="zwBox" v-if="!goodsList.length">
				<el-image :src="require('@/static/zw.svg')"></el-image>
				<p>{{$t('marks.t2')}}</p>
			</div>
			
			<div class="markList f-ct">
				<div class="item f-ct" @click="selMaitou(item)" v-for="(item,index) in goodsList">
					<div class="l flex">
						<p class="nub">{{index+1}}</p>
						<div class="mtNmae">
							<div class="name">
								<span class="def" v-if="item.isDefault">{{$t('marks.t3')}}</span>
								<span class="nameTxt">{{item.memberMarks}}</span>
							</div>
							<!-- <div class="pone">{{item.mobile}}</div> -->
						</div>
					</div>
					<div class="btnBox f-ct" @click.stop="openAddDialog(item)">
						<el-image :src="require('@/static/sel/18.svg')"></el-image>
						<p>{{$t('marks.t4')}}</p>
					</div>
					<div class="bor"></div>
					<div class="btnBox f-ct" @click.stop="memberCodeRemove(item.id)">
						<el-image :src="require('@/static/sel/19.svg')"></el-image>
						<p>{{$t('marks.t5')}}</p>
					</div>
				</div>
			</div>
			
		</div>
		
		<!-- ===== 操作按钮区 ===== -->
		<div class="action-bar animate__animated  ">
			<el-button type="primary" class="submit-btn" @click="selItem = '',openAddDialog('')">{{$t('marks.t6')}}</el-button>
		</div>

		<!-- ===== 添加唛头弹窗 ===== -->
		<el-dialog
			:visible.sync="addMarkVisible"
			width="764px"
			custom-class="add-mark-dialog"
			:show-close="false"
			:close-on-click-modal="false"
			@close="handleCloseDialog">
			<!-- 自定义头部 -->
			<div slot="title" class="dialog-header">
				<h2 class="dialog-title" v-if="selItem">{{$t('marks.t7')}}</h2>
				<h2 class="dialog-title" v-if="!selItem">{{$t('marks.t6')}}</h2>
				<el-image class="dialog-close-icon" :src="require('@/static/sel/20.svg')" @click="addMarkVisible = false"></el-image>
			</div>

			<!-- 弹窗内容区 -->
			<div class="dialog-body">
				
				<!-- 唛头名称字段 -->
				<div class="form-field">
					<label class="field-label">{{$t('marks.t8')}}</label>
					<el-input
						v-model="memberMarks"
						class="field-input"
						:placeholder="$t('marks.t9')"
						clearable
					></el-input>
				</div>
				
				<!-- <div class="form-field">
					<label class="field-label">{{$t('marks.t10')}}</label>
					<el-input
						v-model="mobile"
						class="field-input"
						:placeholder="$t('marks.t11')"
						clearable
					></el-input>
				</div> -->

				<!-- 是否默认选择 -->
				<div class="form-field">
					<label class="field-label field-label--center">{{$t('marks.t12')}}</label>
					<div class="radio-group">
						
						<!-- 是选项 -->
						<div
						class="radio-option"
						:class="{ 'is-selected': isDefault === true }"
						@click="isDefault = !isDefault">
							<div class="radio-icon-wrap">
								<!-- 选中状态：显示选中图标 -->
								<el-image
									v-if="isDefault === true"
									class="radio-sel-icon"
									:src="iconSel"
								></el-image>
								<!-- 未选中状态：显示未选中图标 -->
								<div v-else class="radio-unsel-wrap">
									<el-image
										class="radio-unsel-outer"
										:src="iconUnsel"
									></el-image>
								</div>
							</div>
							<span class="option-text">{{$t('marks.t13')}}</span>
						</div>

						<!-- 否选项 -->
						<div
						class="radio-option"
						:class="{ 'is-selected': isDefault === false }"
						@click="isDefault = !isDefault">
							<div class="radio-icon-wrap">
								<!-- 选中状态：显示选中图标 -->
								<el-image
									v-if="isDefault === false"
									class="radio-sel-icon"
									:src="iconSel"
								></el-image>
								<!-- 未选中状态：显示未选中图标 -->
								<div v-else class="radio-unsel-wrap">
									<el-image
										class="radio-unsel-outer"
										:src="iconUnsel"
									></el-image>
								</div>
							</div>
							<span class="option-text">{{$t('marks.t14')}}</span>
						</div>

					</div>
				</div>

			</div>

			<!-- 底部按钮区 -->
			<div slot="footer" class="dialog-footer">
				<button class="btn-cancel" @click="addMarkVisible = false">{{$t('marks.t15')}}</button>
				<button class="btn-confirm" v-if="selItem" @click="handleConfirm">{{$t('marks.t16')}}</button>
				<button class="btn-confirm" v-if="!selItem" @click="handleConfirm">{{$t('marks.t17')}}</button>
			</div>

		</el-dialog>
		
	</div>
</template>
<script>
import { 
	memberMarklist,
	memberMarkdetail,
	memberMarkadd,
	memberMarkupdate,
	memberMarkdelete
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			iconSel: require('@/static/sel/1.svg'),
			iconUnsel: require('@/static/sel/2.svg'),
			// 列表
			goodsList:[],
			// 添加唛头弹窗
			selItem:'',
			addMarkVisible: false,
			memberMarks:'',
			mobile:'',
			isDefault: true
		}
	},
	mounted() {
		this.memberMarklistF()
	},
	methods:{
		// 选择唛头
		selMaitou(item){
			// this.$bus.$emit('maitouSel', item)
			// this.back()
		},
		// 删除
		async memberCodeRemove(id){
			const res = await memberMarkdelete({id})
			if(res.code==200){
				this.Tips(res.msg)
				this.memberMarklistF()
			}else{this.Tips(res.msg,'error')}
		},
		// 提交
		async handleConfirm(){
			let res;
			if(this.selItem){
				res = await memberMarkupdate({
					isDefault:this.isDefault?1:0,
					memberMarks:this.memberMarks,
					mobile:this.mobile,
					id:this.selItem.id,
				})
			}else{
				res = await memberMarkadd({
					isDefault:this.isDefault?1:0,
					memberMarks:this.memberMarks,
					mobile:this.mobile,
				})
			}
			if(res.code==200){
				this.addMarkVisible = false
				this.Tips(res.msg)
				this.memberMarklistF()
			}else{this.Tips(res.msg,'error')}
		},
		// 唛头列表
		async memberMarklistF(){
			var res;
			res = await memberMarklist({});
			if(res.code==200){
				this.goodsList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 打开添加唛头弹窗
		openAddDialog(item) {
			if(item){
				this.selItem = item
				this.memberMarks = this.selItem.memberMarks
				this.mobile = this.selItem.mobile
				this.isDefault = this.selItem.isDefault*1?true:false
			}
			this.addMarkVisible = true
		},
		// 关闭弹窗时重置表单
		handleCloseDialog() {
			this.addMarkVisible = false
			this.memberMarks = ''
			this.mobile = ''
			this.isDefault = true
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
/* ========== 设计令牌 ========== */
$primary: #0096FF;
$danger: #FC2933;
$text-dark: #333333;
$text-gray: #999999;
$text-muted: #C6C6C6;
$border-color: #D9D9D9;
$page-bg: #F8F8F8;
$card-bg: #FFFFFF;
$cargo-bg: #FAFCFE;
$info-bg: #FAFAFA;
$thumb-bg: #E7F6FF;
$radius-sm: 0.04rem;
$radius-md: 0.08rem;
$radius-lg: 0.12rem;

$font-lg: 0.20rem;
$font-md: 0.16rem;
$font-sm: 0.14rem;
$font-xs: 0.13rem;

$input-height: 0.50rem;
$gap-section: 0.32rem;
$gap-form: 24px;
$gap-upload: 0.14rem;
$sel-gap: 24px; // 选项间距	

/* ========== 通用区块标题 ========== */
.sec-title {
	display: flex;
	align-items: center;
	padding: 0 12px;
	margin-bottom: 0.16rem;

	.el-image {
		width: 0.02rem;
		height: 0.20rem;
		margin-right: 0.08rem;
		// flex-shrink: 0;
		display: block;
	}

	span {
		font-size: $font-lg;
		font-weight: 500;
		color: $text-dark;
	}
}
.pageFrom{
	width: 100%;
	background: #fff;
	border-radius: 10px;
	padding: 24px 8px;
	margin-top: 24px;
	padding-bottom: 40px;
	.markList{
		.item{
			width: 489px;
			height: 72px;
			padding: 0 24px;
			border: 1px solid #F1F1F1;
			margin: 0 12px;
			margin-bottom: 24px;
			border-radius: 12px;
			justify-content: space-between;
			.l{
				width: calc(100% - 160px);
			}
			.nub{
				height: 21px;
				line-height: 20px;
				background: #0096FF;
				border-radius: 20px;
				padding: 0 6px;
				color: #fff;
				font-size: 13px;
				margin-right: 10px;
				transform: translateY(4px);
			}
			.mtNmae{
				width: calc(100% - 40px);
				.name{
					.def{
						height: 22px;
						border-radius: 4px;
						background: #EBF9FF;
						border-radius: 4px;
						padding: 0 8px;
						color: #0096FF;
						font-size: 14px;
						margin-right: 6px;
						display: inline-block;
					}
					.nameTxt{
						font-size: 16px;
						color: #2F3541;
					}
				}
				.pone{
					font-size: 14px;
					color: #999999;
					margin-top: 4px;
				}
			}
			.btnBox{
				cursor: pointer;
				.el-image{
					width: 14px;
					margin-right: 6px;
				}
				p{
					font-size: 14px;
				}
			}
			.bor{
				width: 1px;
				height: 16px;
				background: #D9D9D9;
				margin: 0 16px;
			}
		}
	}
}
/* ========== 操作按钮区 ========== */
.action-bar {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-top: 0.24rem;
	.submit-btn {
		width: 1.84rem;
		height: 0.60rem;
		border-radius: 0.10rem;
		font-size: 0.18rem;
		font-weight: 500;
		transition: opacity 0.25s ease, transform 0.15s ease;
	
		&:hover {
			opacity: 0.90;
			transform: translateY(-0.01rem);
		}
	
		&:active {
			transform: translateY(0);
			opacity: 1;
		}
	}
}


/* ================================================================
   添加唛头弹窗样式
   ================================================================ */

::v-deep .add-mark-dialog {
	border-radius: 8px;
	overflow: hidden;

	.el-dialog__header {
		padding: 0;
		margin: 0;
	}

	.el-dialog__body {
		padding: 30px 32px 20px;
		padding-bottom: 32px;
	}

	.el-dialog__footer {
		padding: 0 32px 28px;
	}
}


/* ---- 弹窗头部 ---- */
.dialog-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 69px;
	background: #f7fafc;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 0 30px;
	box-sizing: border-box;
}

.dialog-title {
	font-family: 'PingFang SC', sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	line-height: 1;
}

.dialog-close-icon {
	width: 16px;
	height: 16px;
	cursor: pointer;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.7;
	}
}


/* ---- 弹窗内容区 ---- */
.dialog-body {
	display: flex;
	flex-direction: column;
}


/* 表单字段行 */
.form-field {
	display: flex;
	align-items: center;
	margin: auto;
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}


/* 字段标签 */
.field-label {
	width: 80px;
	text-align: right;
	font-size: 16px;
	font-weight: 400;
	color: #9A9DA7;
	flex-shrink: 0;
	line-height: 45px;
	margin-right: 14px;

	&--center {
		text-align: center;
	}
}


/* 输入框 */
.field-input {
	width: 307px;
	
	.el-input__inner {
		height: 41px;
		line-height: 41px;
		border: 2px solid #E8EDF4;
		border-radius: 8px;
		font-size: 16px;
		color: #333333;
		padding: 0 16px;

		&::placeholder {
			color: #999999;
		}

		&:focus {
			border-color: #0096FF;
		}
	}
}


/* ---- 自定义单选组（JS+div实现）---- */
.radio-group {
	display: flex;
	align-items: center;
	width: 307px;
	height: 43px;
	border: 2px solid #E8EDF4;
	border-radius: 8px;
	padding: 0 16px;
	box-sizing: border-box;
	background: white;
}


/* 单选选项 */
.radio-option {
	display: flex;
	align-items: center;
	cursor: pointer;
	margin-right: 40px;
	user-select: none;

	&:last-child {
		margin-right: 0;
	}
}


/* 图标容器 */
.radio-icon-wrap {
	position: relative;
	width: 22px;
	height: 22px;
	margin-right: 10px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}


/* 选中图标 */
.radio-sel-icon {
	width: 22px;
	height: 22px;
	display: block;
}


/* 未选中图标组合 */
.radio-unsel-wrap {
	position: relative;
	width: 22px;
	height: 22px;
	display: block;
}

.radio-unsel-outer {
	width: 22px;
	height: 22px;
	position: absolute;
	top: 0;
	left: 0;
	display: block;
}

.radio-unsel-inner {
	width: 14px;
	height: 14px;
	position: absolute;
	top: 4px;
	left: 4px;
	display: block;
}


/* 选项文字 */
.option-text {
	font-size: 16px;
	font-weight: 400;
	color: #333333;
	line-height: 1;
}


/* ---- 弹窗底部按钮区 ---- */
.dialog-footer {
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 4px;
}


/* 返回按钮 */
.btn-cancel {
	width: 120px;
	height: 44px;
	background: #E9F6FF;
	border: none;
	border-radius: 6px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #0096FF;
	cursor: pointer;
	outline: none;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.85;
	}

	&:active {
		opacity: 1;
	}
}


/* 确认修改按钮 */
.btn-confirm {
	width: 120px;
	height: 44px;
	background: #0096FF;
	border: none;
	border-radius: 6px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #FFFFFF;
	cursor: pointer;
	outline: none;
	margin-left: 14px;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.88;
	}

	&:active {
		opacity: 1;
	}
}
</style>